module.exports = __webpack_public_path__ + "static/media/conchas-shellbox.52565632.png";